import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
export const FEE_RULE_LIST = 'fee.rules.list';
export const FEE_RULE_READ = 'fee.rules.read';
export const FEE_RULE_CREATE_VERSION = 'fee.rules.create-version';
export const FEE_RULE_SUBMIT = 'fee.rules.submit';
export const FEE_RULE_APPROVE = 'fee.rules.approve';
export const FEE_RULE_SUSPEND = 'fee.rules.suspend';
export const FEE_RULE_RETIRE = 'fee.rules.retire';
export const FEE_RULE_IMPACT_ANALYZE = 'fee.rules.impact-analyze';
function feeRuleOperation(id, name, accessType, options = {}) {
    const readonly = options.readonly ?? false;
    return {
        id,
        name,
        labelKey: `operations.feeRules.${id.split('.').at(-1)}.label`,
        descriptionKey: `operations.feeRules.${id.split('.').at(-1)}.description`,
        permission: readonly ? 'organization:accounting:read' : 'organization:accounting:manage',
        permissionId: readonly ? 'organization:accounting:read' : 'organization:accounting:manage',
        module: 'ACCOUNTING',
        requiredModules: ['ACCOUNTING'],
        requiresEntitledModule: true,
        requiredAal: readonly
            ? AuthenticationAssuranceLevel.AAL1
            : AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        requestedScope: {
            organizationId: [{ source: 'query', field: 'organizationId' }],
            branchId: [{ source: 'query', field: 'branchId' }],
        },
        allowedPersonas: ['ORG_ADMIN'],
        allowedActorTypes: [ActorType.USER],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        forcesClientScope: false,
        makerCheckerRequired: !readonly,
        idempotencyPolicy: options.idempotent
            ? IdempotencyPolicy.REQUIRED
            : IdempotencyPolicy.NOT_APPLICABLE,
        concurrencyPolicy: readonly ? ConcurrencyPolicy.NONE : ConcurrencyPolicy.OPTIMISTIC,
        auditPolicy: readonly ? AuditPolicy.READ : AuditPolicy.WRITE,
        privacyClassification: PrivacyClassification.CONFIDENTIAL,
        telemetryId: id,
        httpMethods: readonly ? ['GET'] : ['POST'],
        isReadOnly: readonly,
        isFinancial: true,
        supportDelegationEligible: false,
        delegationPolicy: 'NOT_ALLOWED',
        accessType,
    };
}
export const FEE_RULE_OPERATIONS = {
    [FEE_RULE_LIST]: feeRuleOperation(FEE_RULE_LIST, 'List fee rules', 'READ', { readonly: true }),
    [FEE_RULE_READ]: feeRuleOperation(FEE_RULE_READ, 'Read fee rule', 'READ', { readonly: true }),
    [FEE_RULE_CREATE_VERSION]: feeRuleOperation(FEE_RULE_CREATE_VERSION, 'Create fee-rule version', 'ADMIN', { idempotent: true }),
    [FEE_RULE_SUBMIT]: feeRuleOperation(FEE_RULE_SUBMIT, 'Submit fee rule', 'ADMIN', { idempotent: true }),
    [FEE_RULE_APPROVE]: feeRuleOperation(FEE_RULE_APPROVE, 'Approve fee rule', 'ADMIN', { idempotent: true }),
    [FEE_RULE_SUSPEND]: feeRuleOperation(FEE_RULE_SUSPEND, 'Suspend fee rule', 'ADMIN', { idempotent: true }),
    [FEE_RULE_RETIRE]: feeRuleOperation(FEE_RULE_RETIRE, 'Retire fee rule', 'ADMIN', { idempotent: true }),
    [FEE_RULE_IMPACT_ANALYZE]: feeRuleOperation(FEE_RULE_IMPACT_ANALYZE, 'Analyze fee-rule impact', 'READ', { readonly: true }),
};
export const FEE_RULE_OPERATION_IDS = Object.freeze([
    FEE_RULE_LIST,
    FEE_RULE_READ,
    FEE_RULE_CREATE_VERSION,
    FEE_RULE_SUBMIT,
    FEE_RULE_APPROVE,
    FEE_RULE_SUSPEND,
    FEE_RULE_RETIRE,
    FEE_RULE_IMPACT_ANALYZE,
]);
